import { IPoint } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ILocationPropertyEditable {
  location(): IPropertyEditable<IPoint>;
}

export function instanceOfILocationPropertyEditable(instance: any): instance is ILocationPropertyEditable {
  return instance
      && instance.location
      && instanceOfIPropertyEditable<IPoint>(instance.location());
}
